
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import ProductGCHistory from "@/components/productgc/ProductGCHistory.vue";
import ProductGCProcess from "@/components/productgc/ProductGCProcess.vue";
import ProductGCBalances from "@/components/productgc/ProductGCBalances.vue";
import { getGCModelData } from "@/api/productgc";

export default defineComponent({
  name: "productgc",
  components: {
    ProductGCHistory,
    ProductGCProcess,
    ProductGCBalances,
  },
  data() {
    return {
      loading: true,
      gcmodeldata: [],
      isEnabledCountryGCRedeemButton: true,
      isOverriden: false,
    };
  },
  methods: {
    async getgcmodelData() {
      this.loading = true;
      const response = await getGCModelData();
      this.gcmodeldata = response.data;
      this.isEnabledCountryGCRedeemButton = response.data.isEnabledCountryGCRedeemButton;
      this.loading = false;
    },
  },
  mounted() {
    this.getgcmodelData();
    if (localStorage.getItem("override_cifid") != null) {
      this.isOverriden = true;
    }
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Product GC");
    });
  },
});
